import { Outlet, useNavigate } from 'react-router-dom';
import { useIsFeatureSupported, useUserSelfDetails, userHasRole } from '@steelbuy/data-access';
import { ListingBuyerSearchDataProvider } from '@steelbuy/data-provider';
import { Feature, UserRole } from '@steelbuy/ts-shared';
import { CheckoutContextProvider } from '../../components/checkout/CheckoutContext';
import { SearchFormDataContextProvider } from '../../components/listing-search/SearchFormDataContext';
import { SearchResultsContextProvider } from '../../components/listing-search/SearchResultsContext';
import { RoutePath } from '../../router/Routes';

export const MyCartView = () => {
    const navigate = useNavigate();
    const { data: userModel } = useUserSelfDetails();
    const hasBuyerRole = userHasRole(userModel || null, [UserRole.BUYER]);
    const showCart = useIsFeatureSupported(Feature.CART) && hasBuyerRole;

    if (!showCart) {
        navigate(RoutePath.DASHBOARD);
    }

    return (
        <ListingBuyerSearchDataProvider lazyLoad>
            <SearchFormDataContextProvider>
                <CheckoutContextProvider>
                    <SearchResultsContextProvider>
                        <Outlet />
                    </SearchResultsContextProvider>
                </CheckoutContextProvider>
            </SearchFormDataContextProvider>
        </ListingBuyerSearchDataProvider>
    );
};
